import { useStructureContext } from "../../../context/StructureContext";
import { headerProfitability } from "../../../data/admin";
import StdTable from "./StdTable";

export default function ItemMoveProfitBox() {
  const { type, searchValues, section, printArea } = useStructureContext();

  return "FECREN" in searchValues[section.id] ? (
    <div ref={printArea} className="listBox">
      <StdTable
        type={type}
        style={{ width: "100%" }}
        header={headerProfitability}
        data={
          "results" in searchValues[section.id]
            ? searchValues[section.id].results
            : []
        }
        totals={{
          TOTREN:
            "TOTREN" in searchValues[section.id]
              ? searchValues[section.id].TOTREN
              : "",
          RESREN:
            "RESREN" in searchValues[section.id]
              ? searchValues[section.id].RESREN
              : "",
          TPCOREN:
            "TPCOREN" in searchValues[section.id]
              ? searchValues[section.id].TPCOREN
              : "",
          COMREN:
            "COMREN" in searchValues[section.id]
              ? searchValues[section.id].COMREN
              : "",
          CHAREN:
            "CHAREN" in searchValues[section.id]
              ? searchValues[section.id].CHAREN
              : "",
          TRESREN:
            "TRESREN" in searchValues[section.id]
              ? searchValues[section.id].TRESREN
              : "",
        }}
        className="listTableRow"
      />
    </div>
  ) : (
    <></>
  );
}
